import BasePage from "@Scripts/Pages/BasePage";

export default class ProductListPage extends BasePage {
    public static async init() {
        await super.init();

        this.setPagination();
    }

    private static setPagination() {
        document.getElementById("PagingIndexList")?.addEventListener("change", x => {
            var newUrl = "/it/prodotti/" + (<any>window).App.bag.categoryName + "/" + (<any>window).App.bag.subCategoryNames + "-" + (<any>window).App.bag.categoryCode + "?page=" + (<any>document).querySelector("#PagingIndexList").value;

            if ((<any>window).App.bag.brand) {
                newUrl += "&brand=" + (<any>window).App.bag.brand;
            }

            window.location.href = newUrl;
        });
    }
}